import React from "react";
import { FaLightbulb, FaToggleOn, FaToggleOff, FaVideo, FaWifi } from "react-icons/fa";

const FloorPlan = ({ devices }) => {
  return (
    <div className="relative bg-gray-900 p-4 rounded-xl">
      <h3 className="text-lg font-bold mb-4">Floor Plan</h3>
      <img src="/floor.jpg" alt="Floor Plan" className="w-full rounded" />

      {/* Loop through rooms */}
      {devices.map((room) =>
        room.devices.map((device) => (
          <div
            key={device.id}
            className="absolute group cursor-pointer"
            style={{
              top: device.position.top,
              left: device.position.left,
              transform: "translate(-50%, -50%)",
            }}
          >
            {/* Icon based on type */}
            {device.type === "light" && (
              <FaLightbulb
                className={`text-2xl ${
                  device.state === "ON" ? "text-yellow-400" : "text-gray-500"
                }`}
              />
            )}
            {device.type === "switch" &&
              (device.state === "ON" ? (
                <FaToggleOn className="text-green-400 text-2xl" />
              ) : (
                <FaToggleOff className="text-gray-400 text-2xl" />
              ))}
            {device.type === "camera" && <FaVideo className="text-blue-400 text-2xl" />}
            {device.type === "hub" && <FaWifi className="text-green-400 text-2xl" />}

            {/* Tooltip */}
            <div className="absolute left-1/2 -translate-x-1/2 top-8 bg-gray-800 text-white text-sm rounded p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 w-56 shadow-lg">
              <p className="mb-1">
                <strong>Room:</strong> {room.room}
              </p>
              <p className="mb-1">
                <strong>ID:</strong> {device.id}
              </p>
              {device.type === "camera" ? (
                <>
                  <img
                    src={device.lastSavedPic}
                    alt="Last Snapshot"
                    className="w-full h-24 object-cover rounded mb-2"
                  />
                  <button
                    onClick={() => window.open(device.streamUrl, "_blank")}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs w-full"
                  >
                    Open Stream
                  </button>
                </>
              ) : (
                <>
                  <p>
                    <strong>State:</strong> {device.state}
                  </p>
                  <p>
                    <strong>Last Updated:</strong> {device.lastUpdated}
                  </p>
                </>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default FloorPlan;
